import { apiWrapper } from "@/services/api";

// JSプラグイン
import moment from "@/services/moment";

export const validFrameWithQR = async (frame_id, location_id) => {
  try {
    // 現在時刻+指定の文字列をBase64でエンコードしPOST API
    var currentTime = moment(new Date()).format();
    var securitySession = window.btoa(
      currentTime + "IXOYs2jMqCaymwbvsRw5QPGmecYUhggl"
    );

    await apiWrapper(
      "PUT",
      `frames/${frame_id}/qrcode?master_location_id=${location_id}&security_session=${securitySession}`
    );
  } catch (err) {
    console.log("ERROR!! validFrameWithQR()");
    throw err;
  }
};
